import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-top-bar-config',
  templateUrl: './top-bar-config.component.html',
  styleUrls: ['./top-bar-config.component.scss']
})
export class TopBarConfigComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
